import styled from 'styled-components';
import { TransparentButton } from '../transparent-button/TransparentButton';
export const Container = styled.div `
  flex: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  overflow: auto;
`;
export const TwoFaWrapper = styled.section `
  width: 100%;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;
export const Header = styled.header `
  box-shadow: ${({ theme }) => theme.shadows.sm};

  border-radius: ${({ theme }) => {
    const radius = theme.borderRadius.mediumHigh;
    return `${radius} ${radius} 0 0`;
}};

  position: relative;
  display: flex;
  padding: 1.8rem 0;
  justify-content: center;
`;
export const TwoFaWrap = styled.div `
  max-width: 50rem;
  width: 100%;
`;
export const CustomCloseButton = styled(TransparentButton) `
  position: absolute;
  right: 1.6rem;
`;
export const IconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 3.2rem;
  height: 3.2rem;

  border: ${({ theme }) => `1px solid ${theme.colors.borders.default}`};
  border-radius: ${({ theme }) => theme.borderRadius.highest};

  cursor: pointer;
`;
//# sourceMappingURL=styles.js.map